const ProductDescription = {
  description: 'Title',
  key: 'Key',
  tieredPricing: 'tiered pricing defines a price PER unit within a range',
  volumePricing: 'volume pricing defines a price for ALL units within the range',
  addToRetail: 'in case of non retail rate, determine whether or not the product will be included in the retail price',
};

export default ProductDescription;
